import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d167ef6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "outerContainer" }
const _hoisted_2 = { id: "toolbarSidebar" }
const _hoisted_3 = { class: "splitToolbarButton toggled" }
const _hoisted_4 = {
  id: "viewThumbnail",
  class: "toolbarButton toggled vue-pdf-app-icon view-thumbnail",
  title: "Show Thumbnails",
  tabindex: "2",
  "data-l10n-id": "thumbs"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-l10n-id": "thumbs_label" }, "Thumbnails", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  id: "viewOutline",
  class: "toolbarButton vue-pdf-app-icon view-outline",
  title: "Show Document Outline (double-click to expand/collapse all items)",
  tabindex: "3",
  "data-l10n-id": "document_outline"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-l10n-id": "document_outline_label" }, "Document Outline", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  id: "viewAttachments",
  class: "toolbarButton vue-pdf-app-icon view-attachments",
  title: "Show Attachments",
  tabindex: "4",
  "data-l10n-id": "attachments"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-l10n-id": "attachments_label" }, "Attachments", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { id: "thumbnailView" }
const _hoisted_14 = {
  id: "outlineView",
  class: "hidden"
}
const _hoisted_15 = {
  id: "attachmentsView",
  class: "hidden"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "sidebarResizer",
  class: "hidden"
}, null, -1))
const _hoisted_17 = { id: "mainContainer" }
const _hoisted_18 = {
  class: "findbar hidden doorHanger",
  id: "findbar"
}
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<div id=\"findbarInputContainer\" data-v-0d167ef6><input id=\"findInput\" class=\"toolbarField\" title=\"Find\" placeholder=\"Find in document…\" tabindex=\"91\" data-l10n-id=\"find_input\" data-v-0d167ef6><div class=\"splitToolbarButton\" data-v-0d167ef6><button id=\"findPrevious\" class=\"toolbarButton findPrevious vue-pdf-app-icon find-previous\" title=\"Find the previous occurrence of the phrase\" tabindex=\"92\" data-l10n-id=\"find_previous\" data-v-0d167ef6><span data-l10n-id=\"find_previous_label\" data-v-0d167ef6>Previous</span></button><div class=\"splitToolbarButtonSeparator\" data-v-0d167ef6></div><button id=\"findNext\" class=\"toolbarButton findNext vue-pdf-app-icon find-next\" title=\"Find the next occurrence of the phrase\" tabindex=\"93\" data-l10n-id=\"find_next\" data-v-0d167ef6><span data-l10n-id=\"find_next_label\" data-v-0d167ef6>Next</span></button></div></div><div id=\"findbarOptionsOneContainer\" data-v-0d167ef6><input type=\"checkbox\" id=\"findHighlightAll\" class=\"toolbarField\" tabindex=\"94\" data-v-0d167ef6><label for=\"findHighlightAll\" class=\"toolbarLabel\" data-l10n-id=\"find_highlight\" data-v-0d167ef6>Highlight all</label><input type=\"checkbox\" id=\"findMatchCase\" class=\"toolbarField\" tabindex=\"95\" data-v-0d167ef6><label for=\"findMatchCase\" class=\"toolbarLabel\" data-l10n-id=\"find_match_case_label\" data-v-0d167ef6>Match case</label></div><div id=\"findbarOptionsTwoContainer\" data-v-0d167ef6><input type=\"checkbox\" id=\"findEntireWord\" class=\"toolbarField\" tabindex=\"96\" data-v-0d167ef6><label for=\"findEntireWord\" class=\"toolbarLabel\" data-l10n-id=\"find_entire_word_label\" data-v-0d167ef6>Whole words</label><span id=\"findResultsCount\" class=\"toolbarLabel hidden\" data-v-0d167ef6></span></div><div id=\"findbarMessageContainer\" data-v-0d167ef6><span id=\"findMsg\" class=\"toolbarLabel\" data-v-0d167ef6></span></div>", 4)
const _hoisted_23 = [
  _hoisted_19
]
const _hoisted_24 = {
  id: "secondaryToolbar",
  class: "secondaryToolbar hidden doorHangerRight"
}
const _hoisted_25 = { id: "secondaryToolbarButtonContainer" }
const _hoisted_26 = {
  id: "secondaryPresentationMode",
  class: "secondaryToolbarButton presentationMode visibleLargeView vue-pdf-app-icon presentation-mode",
  title: "Switch to Presentation Mode",
  tabindex: "51",
  "data-l10n-id": "presentation_mode"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-l10n-id": "presentation_mode_label" }, "Presentation Mode", -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-l10n-id": "open_file_label" }, "Open", -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = {
  id: "secondaryPrint",
  class: "secondaryToolbarButton print visibleMediumView vue-pdf-app-icon print-button",
  title: "Print",
  tabindex: "53",
  "data-l10n-id": "print"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-l10n-id": "print_label" }, "Print", -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = {
  id: "secondaryDownload",
  class: "secondaryToolbarButton download visibleMediumView vue-pdf-app-icon download-button",
  title: "Download",
  tabindex: "54",
  "data-l10n-id": "download"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-l10n-id": "download_label" }, "Download", -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = {
  href: "#",
  id: "secondaryViewBookmark",
  class: "secondaryToolbarButton bookmark visibleSmallView vue-pdf-app-icon bookmark-button",
  title: "Current view (copy or open in new window)",
  tabindex: "55",
  "data-l10n-id": "bookmark"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-l10n-id": "bookmark_label" }, "Current View", -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = {
  key: 0,
  class: "horizontalToolbarSeparator visibleLargeView"
}
const _hoisted_41 = {
  id: "firstPage",
  class: "secondaryToolbarButton firstPage vue-pdf-app-icon first-page",
  title: "Go to First Page",
  tabindex: "56",
  "data-l10n-id": "first_page"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-l10n-id": "first_page_label" }, "Go to First Page", -1))
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = {
  id: "lastPage",
  class: "secondaryToolbarButton lastPage vue-pdf-app-icon last-page",
  title: "Go to Last Page",
  tabindex: "57",
  "data-l10n-id": "last_page"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-l10n-id": "last_page_label" }, "Go to Last Page", -1))
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = {
  key: 1,
  class: "horizontalToolbarSeparator"
}
const _hoisted_48 = {
  id: "pageRotateCw",
  class: "secondaryToolbarButton rotateCw vue-pdf-app-icon rotate-clockwise",
  title: "Rotate Clockwise",
  tabindex: "58",
  "data-l10n-id": "page_rotate_cw"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-l10n-id": "page_rotate_cw_label" }, "Rotate Clockwise", -1))
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = {
  id: "pageRotateCcw",
  class: "secondaryToolbarButton rotateCcw vue-pdf-app-icon rotate-counter-clockwise",
  title: "Rotate Counterclockwise",
  tabindex: "59",
  "data-l10n-id": "page_rotate_ccw"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-l10n-id": "page_rotate_ccw_label" }, "Rotate Counterclockwise", -1))
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = {
  key: 2,
  class: "horizontalToolbarSeparator"
}
const _hoisted_55 = {
  id: "cursorSelectTool",
  class: "secondaryToolbarButton selectTool toggled vue-pdf-app-icon select-tool",
  title: "Enable Text Selection Tool",
  tabindex: "60",
  "data-l10n-id": "cursor_text_select_tool"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-l10n-id": "cursor_text_select_tool_label" }, "Text Selection Tool", -1))
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = {
  id: "cursorHandTool",
  class: "secondaryToolbarButton handTool vue-pdf-app-icon hand-tool",
  title: "Enable Hand Tool",
  tabindex: "61",
  "data-l10n-id": "cursor_hand_tool"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-l10n-id": "cursor_hand_tool_label" }, "Hand Tool", -1))
const _hoisted_60 = [
  _hoisted_59
]
const _hoisted_61 = {
  key: 3,
  class: "horizontalToolbarSeparator"
}
const _hoisted_62 = {
  id: "scrollVertical",
  class: "secondaryToolbarButton scrollModeButtons scrollVertical toggled vue-pdf-app-icon scroll-vertical",
  title: "Use Vertical Scrolling",
  tabindex: "62",
  "data-l10n-id": "scroll_vertical"
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-l10n-id": "scroll_vertical_label" }, "Vertical Scrolling", -1))
const _hoisted_64 = [
  _hoisted_63
]
const _hoisted_65 = {
  id: "scrollHorizontal",
  class: "secondaryToolbarButton scrollModeButtons scrollHorizontal vue-pdf-app-icon scroll-horizontal",
  title: "Use Horizontal Scrolling",
  tabindex: "63",
  "data-l10n-id": "scroll_horizontal"
}
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-l10n-id": "scroll_horizontal_label" }, "Horizontal Scrolling", -1))
const _hoisted_67 = [
  _hoisted_66
]
const _hoisted_68 = {
  id: "scrollWrapped",
  class: "secondaryToolbarButton scrollModeButtons scrollWrapped vue-pdf-app-icon scroll-wrapped",
  title: "Use Wrapped Scrolling",
  tabindex: "64",
  "data-l10n-id": "scroll_wrapped"
}
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-l10n-id": "scroll_wrapped_label" }, "Wrapped Scrolling", -1))
const _hoisted_70 = [
  _hoisted_69
]
const _hoisted_71 = {
  key: 4,
  class: "horizontalToolbarSeparator scrollModeButtons"
}
const _hoisted_72 = {
  id: "spreadNone",
  class: "secondaryToolbarButton spreadModeButtons spreadNone toggled vue-pdf-app-icon spread-none",
  title: "Do not join page spreads",
  tabindex: "65",
  "data-l10n-id": "spread_none"
}
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-l10n-id": "spread_none_label" }, "No Spreads", -1))
const _hoisted_74 = [
  _hoisted_73
]
const _hoisted_75 = {
  id: "spreadOdd",
  class: "secondaryToolbarButton spreadModeButtons vue-pdf-app-icon spread-odd",
  title: "Join page spreads starting with odd-numbered pages",
  tabindex: "66",
  "data-l10n-id": "spread_odd"
}
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-l10n-id": "spread_odd_label" }, "Odd Spreads", -1))
const _hoisted_77 = [
  _hoisted_76
]
const _hoisted_78 = {
  id: "spreadEven",
  class: "secondaryToolbarButton spreadModeButtons spreadEven vue-pdf-app-icon spread-even",
  title: "Join page spreads starting with even-numbered pages",
  tabindex: "67",
  "data-l10n-id": "spread_even"
}
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-l10n-id": "spread_even_label" }, "Even Spreads", -1))
const _hoisted_80 = [
  _hoisted_79
]
const _hoisted_81 = {
  key: 5,
  class: "horizontalToolbarSeparator spreadModeButtons"
}
const _hoisted_82 = {
  id: "documentProperties",
  class: "secondaryToolbarButton documentProperties vue-pdf-app-icon document-properties",
  title: "Document Properties…",
  tabindex: "68",
  "data-l10n-id": "document_properties"
}
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-l10n-id": "document_properties_label" }, "Document Properties…", -1))
const _hoisted_84 = [
  _hoisted_83
]
const _hoisted_85 = { class: "toolbar" }
const _hoisted_86 = { id: "toolbarContainer" }
const _hoisted_87 = { id: "toolbarViewer" }
const _hoisted_88 = { id: "toolbarViewerLeft" }
const _hoisted_89 = {
  id: "sidebarToggle",
  class: "toolbarButton vue-pdf-app-icon sidebar-toggle",
  title: "Toggle Sidebar",
  tabindex: "11",
  "data-l10n-id": "toggle_sidebar"
}
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-l10n-id": "toggle_sidebar_label" }, "Toggle Sidebar", -1))
const _hoisted_91 = [
  _hoisted_90
]
const _hoisted_92 = {
  key: 0,
  class: "toolbarButtonSpacer"
}
const _hoisted_93 = {
  id: "viewFind",
  class: "toolbarButton vue-pdf-app-icon view-find",
  title: "Find in Document",
  tabindex: "12",
  "data-l10n-id": "findbar"
}
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-l10n-id": "findbar_label" }, "Find", -1))
const _hoisted_95 = [
  _hoisted_94
]
const _hoisted_96 = { class: "splitToolbarButton hiddenSmallView" }
const _hoisted_97 = {
  class: "toolbarButton pageUp vue-pdf-app-icon page-up",
  title: "Previous Page",
  id: "previous",
  tabindex: "13",
  "data-l10n-id": "previous"
}
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-l10n-id": "previous_label" }, "Previous", -1))
const _hoisted_99 = [
  _hoisted_98
]
const _hoisted_100 = {
  key: 0,
  class: "splitToolbarButtonSeparator"
}
const _hoisted_101 = {
  class: "toolbarButton pageDown vue-pdf-app-icon page-down",
  title: "Next Page",
  id: "next",
  tabindex: "14",
  "data-l10n-id": "next"
}
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-l10n-id": "next_label" }, "Next", -1))
const _hoisted_103 = [
  _hoisted_102
]
const _hoisted_104 = {
  type: "number",
  id: "pageNumber",
  class: "toolbarField pageNumber",
  title: "Page",
  value: "1",
  size: "4",
  min: "1",
  tabindex: "15",
  "data-l10n-id": "page",
  autocomplete: "off"
}
const _hoisted_105 = {
  id: "numPages",
  class: "toolbarLabel"
}
const _hoisted_106 = { id: "toolbarViewerRight" }
const _hoisted_107 = {
  id: "presentationMode",
  class: "toolbarButton presentationMode hiddenLargeView vue-pdf-app-icon presentation-mode",
  title: "Switch to Presentation Mode",
  tabindex: "31",
  "data-l10n-id": "presentation_mode"
}
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-l10n-id": "presentation_mode_label" }, "Presentation Mode", -1))
const _hoisted_109 = [
  _hoisted_108
]
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-l10n-id": "open_file_label" }, "Open", -1))
const _hoisted_111 = [
  _hoisted_110
]
const _hoisted_112 = {
  id: "print",
  class: "toolbarButton print hiddenMediumView vue-pdf-app-icon print-button",
  title: "Print",
  tabindex: "33",
  "data-l10n-id": "print"
}
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-l10n-id": "print_label" }, "Print", -1))
const _hoisted_114 = [
  _hoisted_113
]
const _hoisted_115 = {
  id: "download",
  class: "toolbarButton download hiddenMediumView vue-pdf-app-icon download-button",
  title: "Download",
  tabindex: "34",
  "data-l10n-id": "download"
}
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-l10n-id": "download_label" }, "Download", -1))
const _hoisted_117 = [
  _hoisted_116
]
const _hoisted_118 = {
  href: "#",
  id: "viewBookmark",
  class: "toolbarButton bookmark hiddenSmallView vue-pdf-app-icon bookmark-button",
  title: "Current view (copy or open in new window)",
  tabindex: "35",
  "data-l10n-id": "bookmark"
}
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-l10n-id": "bookmark_label" }, "Current View", -1))
const _hoisted_120 = [
  _hoisted_119
]
const _hoisted_121 = {
  key: 0,
  class: "verticalToolbarSeparator hiddenSmallView"
}
const _hoisted_122 = {
  id: "secondaryToolbarToggle",
  class: "toolbarButton vue-pdf-app-icon secondary-toolbar-toggle",
  title: "Tools",
  tabindex: "36",
  "data-l10n-id": "tools"
}
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-l10n-id": "tools_label" }, "Tools", -1))
const _hoisted_124 = [
  _hoisted_123
]
const _hoisted_125 = { id: "toolbarViewerMiddle" }
const _hoisted_126 = { class: "splitToolbarButton" }
const _hoisted_127 = {
  id: "zoomOut",
  class: "toolbarButton zoomOut vue-pdf-app-icon zoom-out",
  title: "Zoom Out",
  tabindex: "21",
  "data-l10n-id": "zoom_out"
}
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-l10n-id": "zoom_out_label" }, "Zoom Out", -1))
const _hoisted_129 = [
  _hoisted_128
]
const _hoisted_130 = {
  key: 0,
  class: "splitToolbarButtonSeparator"
}
const _hoisted_131 = {
  id: "zoomIn",
  class: "toolbarButton zoomIn vue-pdf-app-icon zoom-in",
  title: "Zoom In",
  tabindex: "22",
  "data-l10n-id": "zoom_in"
}
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-l10n-id": "zoom_in_label" }, "Zoom In", -1))
const _hoisted_133 = [
  _hoisted_132
]
const _hoisted_134 = {
  id: "scaleSelectContainer",
  class: "dropdownToolbarButton vue-pdf-app-icon dropdown-toolbar-button"
}
const _hoisted_135 = {
  id: "scaleSelect",
  title: "Zoom",
  tabindex: "23",
  "data-l10n-id": "zoom"
}
const _hoisted_136 = /*#__PURE__*/_createStaticVNode("<option id=\"pageAutoOption\" value=\"auto\" selected data-l10n-id=\"page_scale_auto\" data-v-0d167ef6> Automatic Zoom </option><option id=\"pageActualOption\" value=\"page-actual\" data-l10n-id=\"page_scale_actual\" data-v-0d167ef6> Actual Size </option><option id=\"pageFitOption\" value=\"page-fit\" data-l10n-id=\"page_scale_fit\" data-v-0d167ef6> Page Fit </option><option id=\"pageWidthOption\" value=\"page-width\" data-l10n-id=\"page_scale_width\" data-v-0d167ef6> Page Width </option><option id=\"customScaleOption\" value=\"custom\" disabled hidden=\"true\" data-v-0d167ef6></option>", 5)
const _hoisted_141 = ["data-l10n-args"]
const _hoisted_142 = ["data-l10n-args"]
const _hoisted_143 = ["data-l10n-args"]
const _hoisted_144 = ["data-l10n-args"]
const _hoisted_145 = ["data-l10n-args"]
const _hoisted_146 = ["data-l10n-args"]
const _hoisted_147 = ["data-l10n-args"]
const _hoisted_148 = ["data-l10n-args"]
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "loadingBar" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "progress" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "glimmer" })
  ])
], -1))
const _hoisted_150 = {
  type: "context",
  id: "viewerContextMenu"
}
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "contextFirstPage",
  label: "First Page",
  "data-l10n-id": "first_page"
}, null, -1))
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "contextLastPage",
  label: "Last Page",
  "data-l10n-id": "last_page"
}, null, -1))
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "contextPageRotateCw",
  label: "Rotate Clockwise",
  "data-l10n-id": "page_rotate_cw"
}, null, -1))
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "contextPageRotateCcw",
  label: "Rotate Counter-Clockwise",
  "data-l10n-id": "page_rotate_ccw"
}, null, -1))
const _hoisted_155 = [
  _hoisted_151,
  _hoisted_152,
  _hoisted_153,
  _hoisted_154
]
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "viewer",
  class: "pdfViewer"
}, null, -1))
const _hoisted_157 = [
  _hoisted_156
]
const _hoisted_158 = {
  id: "errorWrapper",
  hidden: "true"
}
const _hoisted_159 = /*#__PURE__*/_createStaticVNode("<div id=\"errorMessageLeft\" data-v-0d167ef6><span id=\"errorMessage\" data-v-0d167ef6></span><button id=\"errorShowMore\" data-l10n-id=\"error_more_info\" data-v-0d167ef6> More Information </button><button id=\"errorShowLess\" data-l10n-id=\"error_less_info\" hidden=\"true\" data-v-0d167ef6> Less Information </button></div><div id=\"errorMessageRight\" data-v-0d167ef6><button id=\"errorClose\" data-l10n-id=\"error_close\" data-v-0d167ef6>Close</button></div><div class=\"clearBoth\" data-v-0d167ef6></div><textarea id=\"errorMoreInfo\" hidden=\"true\" readonly data-v-0d167ef6></textarea>", 4)
const _hoisted_163 = [
  _hoisted_159
]
const _hoisted_164 = /*#__PURE__*/_createStaticVNode("<div id=\"overlayContainer\" class=\"hidden\" data-v-0d167ef6><div id=\"passwordOverlay\" class=\"container hidden\" data-v-0d167ef6><div class=\"dialog\" data-v-0d167ef6><div class=\"row\" data-v-0d167ef6><p id=\"passwordText\" data-l10n-id=\"password_label\" data-v-0d167ef6> Enter the password to open this PDF file: </p></div><div class=\"row\" data-v-0d167ef6><input type=\"password\" id=\"password\" class=\"toolbarField\" data-v-0d167ef6></div><div class=\"buttonRow\" data-v-0d167ef6><button id=\"passwordCancel\" class=\"overlayButton\" data-v-0d167ef6><span data-l10n-id=\"password_cancel\" data-v-0d167ef6>Cancel</span></button><button id=\"passwordSubmit\" class=\"overlayButton\" data-v-0d167ef6><span data-l10n-id=\"password_ok\" data-v-0d167ef6>OK</span></button></div></div></div><div id=\"documentPropertiesOverlay\" class=\"container hidden\" data-v-0d167ef6><div class=\"dialog\" data-v-0d167ef6><div class=\"row\" data-v-0d167ef6><span data-l10n-id=\"document_properties_file_name\" data-v-0d167ef6>File name:</span><p id=\"fileNameField\" data-v-0d167ef6>-</p></div><div class=\"row\" data-v-0d167ef6><span data-l10n-id=\"document_properties_file_size\" data-v-0d167ef6>File size:</span><p id=\"fileSizeField\" data-v-0d167ef6>-</p></div><div class=\"separator\" data-v-0d167ef6></div><div class=\"row\" data-v-0d167ef6><span data-l10n-id=\"document_properties_title\" data-v-0d167ef6>Title:</span><p id=\"titleField\" data-v-0d167ef6>-</p></div><div class=\"row\" data-v-0d167ef6><span data-l10n-id=\"document_properties_author\" data-v-0d167ef6>Author:</span><p id=\"authorField\" data-v-0d167ef6>-</p></div><div class=\"row\" data-v-0d167ef6><span data-l10n-id=\"document_properties_subject\" data-v-0d167ef6>Subject:</span><p id=\"subjectField\" data-v-0d167ef6>-</p></div><div class=\"row\" data-v-0d167ef6><span data-l10n-id=\"document_properties_keywords\" data-v-0d167ef6>Keywords:</span><p id=\"keywordsField\" data-v-0d167ef6>-</p></div><div class=\"row\" data-v-0d167ef6><span data-l10n-id=\"document_properties_creation_date\" data-v-0d167ef6>Creation Date:</span><p id=\"creationDateField\" data-v-0d167ef6>-</p></div><div class=\"row\" data-v-0d167ef6><span data-l10n-id=\"document_properties_modification_date\" data-v-0d167ef6>Modification Date:</span><p id=\"modificationDateField\" data-v-0d167ef6>-</p></div><div class=\"row\" data-v-0d167ef6><span data-l10n-id=\"document_properties_creator\" data-v-0d167ef6>Creator:</span><p id=\"creatorField\" data-v-0d167ef6>-</p></div><div class=\"separator\" data-v-0d167ef6></div><div class=\"row\" data-v-0d167ef6><span data-l10n-id=\"document_properties_producer\" data-v-0d167ef6>PDF Producer:</span><p id=\"producerField\" data-v-0d167ef6>-</p></div><div class=\"row\" data-v-0d167ef6><span data-l10n-id=\"document_properties_version\" data-v-0d167ef6>PDF Version:</span><p id=\"versionField\" data-v-0d167ef6>-</p></div><div class=\"row\" data-v-0d167ef6><span data-l10n-id=\"document_properties_page_count\" data-v-0d167ef6>Page Count:</span><p id=\"pageCountField\" data-v-0d167ef6>-</p></div><div class=\"row\" data-v-0d167ef6><span data-l10n-id=\"document_properties_page_size\" data-v-0d167ef6>Page Size:</span><p id=\"pageSizeField\" data-v-0d167ef6>-</p></div><div class=\"separator\" data-v-0d167ef6></div><div class=\"row\" data-v-0d167ef6><span data-l10n-id=\"document_properties_linearized\" data-v-0d167ef6>Fast Web View:</span><p id=\"linearizedField\" data-v-0d167ef6>-</p></div><div class=\"buttonRow\" data-v-0d167ef6><button id=\"documentPropertiesClose\" class=\"overlayButton\" data-v-0d167ef6><span data-l10n-id=\"document_properties_close\" data-v-0d167ef6>Close</span></button></div></div></div><div id=\"printServiceOverlay\" class=\"container hidden\" data-v-0d167ef6><div class=\"dialog\" data-v-0d167ef6><div class=\"row\" data-v-0d167ef6><span data-l10n-id=\"print_progress_message\" data-v-0d167ef6>Preparing document for printing…</span></div><div class=\"row\" data-v-0d167ef6><progress value=\"0\" max=\"100\" data-v-0d167ef6></progress><span data-l10n-id=\"print_progress_percent\" data-l10n-args=\"{ &#39;progress&#39;: 0 }\" class=\"relative-progress\" data-v-0d167ef6>0%</span></div><div class=\"buttonRow\" data-v-0d167ef6><button id=\"printCancel\" class=\"overlayButton\" data-v-0d167ef6><span data-l10n-id=\"print_progress_close\" data-v-0d167ef6>Cancel</span></button></div></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: "vuePdfApp",
    class: _normalizeClass([[_ctx.localTheme], "pdf-app"])
  }, [
    (_openBlock(), _createBlock(_resolveDynamicComponent('script'), { type: "application/l10n" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.defaultLocale), 1)
      ]),
      _: 1
    })),
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass([_ctx.isToolbarHidden]),
        id: "sidebarContainer"
      }, [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "toolbar-sidebar-prepend", _normalizeProps(_guardReactiveProps(_ctx.slotProps)), undefined, true),
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("button", _hoisted_4, _hoisted_6, 512), [
              [_vShow, _ctx.showElem('sidebar.viewThumbnail', 'viewThumbnail')]
            ]),
            _withDirectives(_createElementVNode("button", _hoisted_7, _hoisted_9, 512), [
              [_vShow, _ctx.showElem('sidebar.viewOutline', 'viewOutline')]
            ]),
            _withDirectives(_createElementVNode("button", _hoisted_10, _hoisted_12, 512), [
              [_vShow, _ctx.showElem('sidebar.viewAttachments', 'viewAttachments')]
            ])
          ]),
          _renderSlot(_ctx.$slots, "toolbar-sidebar-append", _normalizeProps(_guardReactiveProps(_ctx.slotProps)), undefined, true)
        ], 512), [
          [_vShow, !_ctx.isSidebarToolbarHidden]
        ]),
        _withDirectives(_createElementVNode("div", {
          class: _normalizeClass({ 'zero-top': _ctx.isSidebarToolbarHidden }),
          id: "sidebarContent"
        }, [
          _withDirectives(_createElementVNode("div", _hoisted_13, null, 512), [
            [_vShow, _ctx.showElem('sidebar.viewThumbnail')]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_14, null, 512), [
            [_vShow, _ctx.showElem('sidebar.viewOutline')]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_15, null, 512), [
            [_vShow, _ctx.showElem('sidebar.viewAttachments')]
          ])
        ], 2), [
          [_vShow, _ctx.showElem('sidebar')]
        ]),
        _hoisted_16
      ], 2), [
        [_vShow, _ctx.showElem('sidebar')]
      ]),
      _createElementVNode("div", _hoisted_17, [
        _withDirectives(_createElementVNode("div", _hoisted_18, _hoisted_23, 512), [
          [_vShow, _ctx.showElem('toolbar.toolbarViewerLeft.findbar', 'findbar')]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _renderSlot(_ctx.$slots, "secondary-toolbar-prepend", _normalizeProps(_guardReactiveProps(_ctx.slotProps)), undefined, true),
            _withDirectives(_createElementVNode("button", _hoisted_26, _hoisted_28, 512), [
              [_vShow, _ctx.showElem('secondaryToolbar.secondaryPresentationMode')]
            ]),
            _withDirectives(_createElementVNode("button", {
              onClickOnce: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.bindOpenHandler && _ctx.bindOpenHandler(...args))),
              id: "secondaryOpenFile",
              class: "secondaryToolbarButton openFile visibleLargeView vue-pdf-app-icon open-file",
              title: "Open File",
              tabindex: "52",
              "data-l10n-id": "open_file"
            }, _hoisted_30, 544), [
              [_vShow, _ctx.showElem('secondaryToolbar.secondaryOpenFile')]
            ]),
            _withDirectives(_createElementVNode("button", _hoisted_31, _hoisted_33, 512), [
              [_vShow, _ctx.showElem('secondaryToolbar.secondaryPrint')]
            ]),
            _withDirectives(_createElementVNode("button", _hoisted_34, _hoisted_36, 512), [
              [_vShow, _ctx.showElem('secondaryToolbar.secondaryDownload')]
            ]),
            _withDirectives(_createElementVNode("a", _hoisted_37, _hoisted_39, 512), [
              [_vShow, _ctx.showElem('secondaryToolbar.secondaryViewBookmark')]
            ]),
            (
                _ctx.showElem('secondaryToolbar.secondaryPresentationMode') ||
                  _ctx.showElem('secondaryToolbar.secondaryOpenFile') ||
                  _ctx.showElem('secondaryToolbar.secondaryPrint') ||
                  _ctx.showElem('secondaryToolbar.secondaryDownload') ||
                  _ctx.showElem('secondaryToolbar.secondaryViewBookmark')
              )
              ? (_openBlock(), _createElementBlock("div", _hoisted_40))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("button", _hoisted_41, _hoisted_43, 512), [
              [_vShow, _ctx.showElem('secondaryToolbar.firstPage', 'firstPage')]
            ]),
            _withDirectives(_createElementVNode("button", _hoisted_44, _hoisted_46, 512), [
              [_vShow, _ctx.showElem('secondaryToolbar.lastPage', 'lastPage')]
            ]),
            (
                _ctx.showElem('secondaryToolbar.lastPage', 'lastPage') ||
                  _ctx.showElem('secondaryToolbar.firstPage', 'firstPage')
              )
              ? (_openBlock(), _createElementBlock("div", _hoisted_47))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("button", _hoisted_48, _hoisted_50, 512), [
              [_vShow, _ctx.showElem('secondaryToolbar.pageRotateCw', 'pageRotateCw')]
            ]),
            _withDirectives(_createElementVNode("button", _hoisted_51, _hoisted_53, 512), [
              [_vShow, 
                _ctx.showElem('secondaryToolbar.pageRotateCcw', 'pageRotateCcw')
              ]
            ]),
            (
                _ctx.showElem('secondaryToolbar.pageRotateCcw', 'pageRotateCcw') ||
                  _ctx.showElem('secondaryToolbar.pageRotateCw', 'pageRotateCw')
              )
              ? (_openBlock(), _createElementBlock("div", _hoisted_54))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("button", _hoisted_55, _hoisted_57, 512), [
              [_vShow, 
                _ctx.showElem(
                  'secondaryToolbar.cursorSelectTool',
                  'cursorSelectTool'
                )
              ]
            ]),
            _withDirectives(_createElementVNode("button", _hoisted_58, _hoisted_60, 512), [
              [_vShow, 
                _ctx.showElem('secondaryToolbar.cursorHandTool', 'cursorHandTool')
              ]
            ]),
            (
                _ctx.showElem('secondaryToolbar.cursorHandTool', 'cursorHandTool') ||
                  _ctx.showElem(
                    'secondaryToolbar.cursorSelectTool',
                    'cursorSelectTool'
                  )
              )
              ? (_openBlock(), _createElementBlock("div", _hoisted_61))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("button", _hoisted_62, _hoisted_64, 512), [
              [_vShow, 
                _ctx.showElem('secondaryToolbar.scrollVertical', 'scrollVertical')
              ]
            ]),
            _withDirectives(_createElementVNode("button", _hoisted_65, _hoisted_67, 512), [
              [_vShow, 
                _ctx.showElem(
                  'secondaryToolbar.scrollHorizontal',
                  'scrollHorizontal'
                )
              ]
            ]),
            _withDirectives(_createElementVNode("button", _hoisted_68, _hoisted_70, 512), [
              [_vShow, 
                _ctx.showElem('secondaryToolbar.scrollWrapped', 'scrollWrapped')
              ]
            ]),
            (
                _ctx.showElem('secondaryToolbar.scrollWrapped', 'scrollWrapped') ||
                  _ctx.showElem(
                    'secondaryToolbar.scrollHorizontal',
                    'scrollHorizontal'
                  ) ||
                  _ctx.showElem('secondaryToolbar.scrollVertical', 'scrollVertical')
              )
              ? (_openBlock(), _createElementBlock("div", _hoisted_71))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("button", _hoisted_72, _hoisted_74, 512), [
              [_vShow, _ctx.showElem('secondaryToolbar.spreadNone', 'spreadNone')]
            ]),
            _withDirectives(_createElementVNode("button", _hoisted_75, _hoisted_77, 512), [
              [_vShow, _ctx.showElem('secondaryToolbar.spreadOdd', 'spreadOdd')]
            ]),
            _withDirectives(_createElementVNode("button", _hoisted_78, _hoisted_80, 512), [
              [_vShow, _ctx.showElem('secondaryToolbar.spreadEven', 'spreadEven')]
            ]),
            (
                _ctx.showElem('secondaryToolbar.spreadEven', 'spreadEven') ||
                  _ctx.showElem('secondaryToolbar.spreadOdd', 'spreadOdd') ||
                  _ctx.showElem('secondaryToolbar.spreadNone', 'spreadNone')
              )
              ? (_openBlock(), _createElementBlock("div", _hoisted_81))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("button", _hoisted_82, _hoisted_84, 512), [
              [_vShow, 
                _ctx.showElem(
                  'secondaryToolbar.documentProperties',
                  'documentProperties'
                )
              ]
            ]),
            _renderSlot(_ctx.$slots, "secondary-toolbar-append", _normalizeProps(_guardReactiveProps(_ctx.slotProps)), undefined, true)
          ])
        ], 512), [
          [_vShow, _ctx.showElem('secondaryToolbar')]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_85, [
          _createElementVNode("div", _hoisted_86, [
            _createElementVNode("div", _hoisted_87, [
              _createElementVNode("div", _hoisted_88, [
                _renderSlot(_ctx.$slots, "toolbar-left-prepend", _normalizeProps(_guardReactiveProps(_ctx.slotProps)), undefined, true),
                _withDirectives(_createElementVNode("button", _hoisted_89, _hoisted_91, 512), [
                  [_vShow, _ctx.showElem('sidebar', 'sidebarToggle')]
                ]),
                (_ctx.showElem('sidebar'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_92))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("button", _hoisted_93, _hoisted_95, 512), [
                  [_vShow, 
                    _ctx.showElem(
                      'toolbar.toolbarViewerLeft.findbar',
                      'toggleFindbar'
                    )
                  ]
                ]),
                _createElementVNode("div", _hoisted_96, [
                  _withDirectives(_createElementVNode("button", _hoisted_97, _hoisted_99, 512), [
                    [_vShow, 
                      _ctx.showElem(
                        'toolbar.toolbarViewerLeft.previous',
                        'previousPage'
                      )
                    ]
                  ]),
                  (
                      _ctx.showElem('toolbar.toolbarViewerLeft.next', 'nextPage') &&
                        _ctx.showElem(
                          'toolbar.toolbarViewerLeft.previous',
                          'previousPage'
                        )
                    )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_100))
                    : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("button", _hoisted_101, _hoisted_103, 512), [
                    [_vShow, 
                      _ctx.showElem('toolbar.toolbarViewerLeft.next', 'nextPage')
                    ]
                  ])
                ]),
                _withDirectives(_createElementVNode("input", _hoisted_104, null, 512), [
                  [_vShow, 
                    _ctx.showElem(
                      'toolbar.toolbarViewerLeft.pageNumber',
                      'pageNumber'
                    )
                  ]
                ]),
                _withDirectives(_createElementVNode("span", _hoisted_105, null, 512), [
                  [_vShow, 
                    _ctx.showElem('toolbar.toolbarViewerLeft.pageNumber', 'numPages')
                  ]
                ]),
                _renderSlot(_ctx.$slots, "toolbar-left-append", _normalizeProps(_guardReactiveProps(_ctx.slotProps)), undefined, true)
              ]),
              _createElementVNode("div", _hoisted_106, [
                _renderSlot(_ctx.$slots, "toolbar-right-prepend", _normalizeProps(_guardReactiveProps(_ctx.slotProps)), undefined, true),
                _withDirectives(_createElementVNode("button", _hoisted_107, _hoisted_109, 512), [
                  [_vShow, 
                    _ctx.showElem(
                      'toolbar.toolbarViewerRight.presentationMode',
                      'presentationMode'
                    )
                  ]
                ]),
                _withDirectives(_createElementVNode("button", {
                  onClickOnce: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.bindOpenHandler && _ctx.bindOpenHandler(...args))),
                  id: "openFile",
                  class: "toolbarButton openFile hiddenLargeView vue-pdf-app-icon open-file",
                  title: "Open File",
                  tabindex: "32",
                  "data-l10n-id": "open_file"
                }, _hoisted_111, 544), [
                  [_vShow, 
                    _ctx.showElem('toolbar.toolbarViewerRight.openFile', 'openFile')
                  ]
                ]),
                _withDirectives(_createElementVNode("button", _hoisted_112, _hoisted_114, 512), [
                  [_vShow, _ctx.showElem('toolbar.toolbarViewerRight.print', 'print')]
                ]),
                _withDirectives(_createElementVNode("button", _hoisted_115, _hoisted_117, 512), [
                  [_vShow, 
                    _ctx.showElem('toolbar.toolbarViewerRight.download', 'download')
                  ]
                ]),
                _withDirectives(_createElementVNode("a", _hoisted_118, _hoisted_120, 512), [
                  [_vShow, 
                    _ctx.showElem(
                      'toolbar.toolbarViewerRight.viewBookmark',
                      'viewBookmark'
                    )
                  ]
                ]),
                (_ctx.showElem('secondaryToolbar'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_121))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("button", _hoisted_122, _hoisted_124, 512), [
                  [_vShow, _ctx.showElem('secondaryToolbar')]
                ]),
                _renderSlot(_ctx.$slots, "toolbar-right-append", _normalizeProps(_guardReactiveProps(_ctx.slotProps)), undefined, true)
              ]),
              _createElementVNode("div", _hoisted_125, [
                _renderSlot(_ctx.$slots, "toolbar-middle-prepend", _normalizeProps(_guardReactiveProps(_ctx.slotProps)), undefined, true),
                _createElementVNode("div", _hoisted_126, [
                  _withDirectives(_createElementVNode("button", _hoisted_127, _hoisted_129, 512), [
                    [_vShow, 
                      _ctx.showElem('toolbar.toolbarViewerMiddle.zoomOut', 'zoomOut')
                    ]
                  ]),
                  (
                      _ctx.showElem(
                        'toolbar.toolbarViewerMiddle.zoomIn',
                        'zoomIn'
                      ) &&
                        _ctx.showElem(
                          'toolbar.toolbarViewerMiddle.zoomOut',
                          'zoomOut'
                        )
                    )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_130))
                    : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("button", _hoisted_131, _hoisted_133, 512), [
                    [_vShow, 
                      _ctx.showElem('toolbar.toolbarViewerMiddle.zoomIn', 'zoomIn')
                    ]
                  ])
                ]),
                _withDirectives(_createElementVNode("span", _hoisted_134, [
                  _createElementVNode("select", _hoisted_135, [
                    _hoisted_136,
                    _createElementVNode("option", {
                      "data-l10n-args": _ctx.getScale(50),
                      value: "0.5",
                      "data-l10n-id": "page_scale_percent"
                    }, " 50% ", 8, _hoisted_141),
                    _createElementVNode("option", {
                      "data-l10n-args": _ctx.getScale(75),
                      value: "0.75",
                      "data-l10n-id": "page_scale_percent"
                    }, " 75% ", 8, _hoisted_142),
                    _createElementVNode("option", {
                      "data-l10n-args": _ctx.getScale(100),
                      value: "1",
                      "data-l10n-id": "page_scale_percent"
                    }, " 100% ", 8, _hoisted_143),
                    _createElementVNode("option", {
                      "data-l10n-args": _ctx.getScale(125),
                      value: "1.25",
                      "data-l10n-id": "page_scale_percent"
                    }, " 125% ", 8, _hoisted_144),
                    _createElementVNode("option", {
                      "data-l10n-args": _ctx.getScale(150),
                      value: "1.5",
                      "data-l10n-id": "page_scale_percent"
                    }, " 150% ", 8, _hoisted_145),
                    _createElementVNode("option", {
                      "data-l10n-args": _ctx.getScale(200),
                      value: "2",
                      "data-l10n-id": "page_scale_percent"
                    }, " 200% ", 8, _hoisted_146),
                    _createElementVNode("option", {
                      "data-l10n-args": _ctx.getScale(300),
                      value: "3",
                      "data-l10n-id": "page_scale_percent"
                    }, " 300% ", 8, _hoisted_147),
                    _createElementVNode("option", {
                      "data-l10n-args": _ctx.getScale(400),
                      value: "4",
                      "data-l10n-id": "page_scale_percent"
                    }, " 400% ", 8, _hoisted_148)
                  ])
                ], 512), [
                  [_vShow, 
                    _ctx.showElem('toolbar.toolbarViewerMiddle.scaleSelectContainer')
                  ]
                ]),
                _renderSlot(_ctx.$slots, "toolbar-middle-append", _normalizeProps(_guardReactiveProps(_ctx.slotProps)), undefined, true)
              ])
            ])
          ])
        ], 512), [
          [_vShow, _ctx.showElem('toolbar')]
        ]),
        _hoisted_149,
        _withDirectives(_createElementVNode("menu", _hoisted_150, _hoisted_155, 512), [
          [_vShow, false]
        ]),
        _renderSlot(_ctx.$slots, "viewer-header", _normalizeProps(_guardReactiveProps(_ctx.slotProps)), undefined, true),
        _renderSlot(_ctx.$slots, "viewer-prepend", _normalizeProps(_guardReactiveProps(_ctx.slotProps)), undefined, true),
        _createElementVNode("div", {
          id: "viewerContainer",
          class: _normalizeClass([_ctx.isToolbarHidden]),
          tabindex: "0"
        }, _hoisted_157, 2),
        _renderSlot(_ctx.$slots, "viewer-append", _normalizeProps(_guardReactiveProps(_ctx.slotProps)), undefined, true),
        _renderSlot(_ctx.$slots, "viewer-footer", _normalizeProps(_guardReactiveProps(_ctx.slotProps)), undefined, true),
        _withDirectives(_createElementVNode("div", _hoisted_158, _hoisted_163, 512), [
          [_vShow, _ctx.showElem('errorWrapper')]
        ])
      ]),
      _hoisted_164
    ]),
    _renderSlot(_ctx.$slots, "footer", _normalizeProps(_guardReactiveProps(_ctx.slotProps)), undefined, true)
  ], 2))
}